import React from "react";
import styled from "styled-components";
import FarmyModal from "./FarmyModal";
import currentTheme from "../../../react-themes/theme";
import ModalCloseButton from "./ModalCloseButton";

const theme = currentTheme();

const BasicFarmyModal = (
  {
    children,
    modalName,
    hideCloseButton,
    hide,
    onClose = () => {},
    closeOnClickOutside,
    beforeOpen,
    ...additionalProps
  }
) => {
  const parentProps = {
    modalName,
    hide,
    onClose,
    closeOnClickOutside,
    beforeOpen,
    ...additionalProps
  };

  return (
    <FarmyModal
      {...parentProps}
    >
      <StyleModalWrapper hideCloseButton={hideCloseButton}>
        <StyledFarmyModal style={additionalProps?.style}>
          <div className='content'>
            {children}
          </div>
        </StyledFarmyModal>

        {!hideCloseButton &&
          <ModalCloseButton modalName={modalName} onClose={onClose}/>
        }
      </StyleModalWrapper>
    </FarmyModal>
  );
};
export default BasicFarmyModal;

const StyledFarmyModal = styled.div.attrs(props => ({
  className: props.className || `
  flex
  justify-content-center
  flex-direction-column`,
  style: {...props.style || theme.modals.basicStyles}
}))`
  
  .h4.modal-title {
    font-weight: 700;
    font-size: 24px;
  }
`;

const StyleModalWrapper = styled.div`
  padding-top: ${props => (props.hideCloseButton ? "" : "5px")}
`;
